import styled from "styled-components";
import { theme } from "../../../theme";
import { Container } from "../../../common/styles";

export const Section = styled(Container)`
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    gap: 5%;
    @media (max-width: ${theme.breakpoints.tablet}) {
       flex-direction: column;
    }
`;

export const Img = styled.img`
    width: 500px;
    @media (max-width: ${theme.breakpoints.tablet}) {
       width: 85%;
       margin: 0 auto;
    }
`;

export const TextBlock = styled.div`
    max-width: 600px;
    font-size: 17px;
    font-weight: ${theme.fonts.weights.light};
    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 14px;
    }
`;

export const Text = styled.div`
    padding-bottom: 20px;
    @media (max-width: ${theme.breakpoints.mobile}) {
        padding-bottom: 10px;
    }
`;

export const ListBlock = styled.ul`
    list-style-type: "⬤";
    padding-left: 20px;
`;

export const ListElement = styled.li`
    padding: 10px 0 10px;
    padding-left: 10px;
    &::marker{
        padding: 5px;
        color: ${theme.colors.colorfulBackground};
    }
`;